// extracted by mini-css-extract-plugin
export default {"title":"FifthScreen_title__-1VN7","row":"FifthScreen_row__nQrrD","description":"FifthScreen_description__0GCHu","more":"FifthScreen_more__BEcgN"};